export const sidebarpage = [

    {
        href: "#home",
        title: "Início"
    },

    {
        href: "#about",
        title: "Por que?"
    },


    {
        href: "#experience",
        title: "Sobre Nós"
    },


    {
        href: "#service",
        title: "Funcionalidades"
    },

    {
        href: "#portfolio",
        title: "Lojas"
    },

    {
        href: "#news",
        title: "Novidades"
    },

    {
        href: "#contact",
        title: "Cadastrar!"
    },

]